/**
 * Session Timer component.
 * @module components/LoginUnico/LogiUnicoSessionTimer
 */
import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { defineMessages, useIntl } from 'react-intl';
import Cookies from 'universal-cookie';
import { toast } from 'react-toastify';
import { Toast } from '@plone/volto/components';
import { useHistory } from 'react-router-dom';
import { getCookieOptions } from '@plone/volto/helpers';
import { isActive, renewLogin } from '../../actions';
import './timer.css';


// loginunico remaining_session_time
let remaining_session_time = React.createRef();

const messages = defineMessages({
    yourSessionWillExpire5Min: {
      id: 'your_session_will_expire_5_min',
      defaultMessage: 'Your session will expire in 5 minutes.'
    },
    saveOrBrowse: {
      id: 'save_or_browse',
      defaultMessage: 'Save your changes or browse the site to renew it.',
    }
  });

function zero_pad(number_str){
    return number_str.padStart(2, "0");
}

function convert_seconds(total_secs){
    var hours = Math.floor(total_secs / 3600000);
    var rest = Math.floor(total_secs % 3600000);
    var minutes = Math.floor(rest / 60000);
    rest = Math.floor(rest % 60000);
    var seconds = Math.floor(rest / 1000);
    return zero_pad(hours.toString()) + ":" + zero_pad(minutes.toString()) + ":" + zero_pad(seconds.toString());
}

function get_auth_token_current_value(cookies){
  return cookies.get('auth_token');
}

function set_auth_token(cookies, value, expires){
  if ( value ) {
    // secure = true se https por padrao do helper
    cookies.set(
      'auth_token',
      value,
      getCookieOptions({
        expires: expires,
      }),
    );
  }
}

function remove_auth_token(cookies) {
  cookies.remove('auth_token', { path: '/' });
}

function get_expires_from_session(){
  return sessionStorage.getItem('auth_expires');
}

function set_expires_to_session(value){
  sessionStorage.setItem('auth_expires', value);
}

function get_interval_id_from_session(){
  return sessionStorage.getItem('interval_id');
}

function set_interval_id_to_session(value){
  sessionStorage.setItem('interval_id', value);
}

/**
 * LoginUnicoSessionTimer component class.
 * @function LoginUnicoSessionTimer
 * @param {Object} intl Intl object
 * @returns {string} Markup of the component.
 */
const LoginUnicoSessionTimer = (props) => {
    const history = useHistory();
    const intl = useIntl();
    const dispatch = useDispatch();

    // is_active
    useEffect(() => {
        dispatch(
        isActive(),
        );
    }, [dispatch]);
    const is_active = useSelector((state) => state.is_active.is_active);
    // renew_login
    useEffect(() => {
    dispatch(
        renewLogin(),
    );
    }, [dispatch]);
    const renew_login_enabled = useSelector((state) => state.loginunico_renew_login.renew_login_enabled);
    const session_expired_msg_enabled = useSelector((state) => state.loginunico_renew_login.session_expired_msg_enabled);
    const date_time_now = useSelector((state) => state.loginunico_renew_login.date_time_now);
    let now = new Date(date_time_now);
    const expires_gmt_3 = useSelector((state) => state.loginunico_renew_login.expires_gmt_3);
    let expires = new Date(expires_gmt_3);

    if ( is_active && renew_login_enabled ) {
      // renovacao do cookie
      const cookies = new Cookies();
      const current_value = get_auth_token_current_value(cookies);
      set_auth_token(cookies, current_value, expires);
      // interval
      let exp_from_session = get_expires_from_session() || null;
      let interval_id_from_session = get_interval_id_from_session() || null;
      if ( (! exp_from_session) || (expires != exp_from_session ) ){
        if ( interval_id_from_session ) {
          clearInterval(interval_id_from_session);
        }
        set_expires_to_session(expires);
        let start = now.getTime();
        let end = expires.getTime();
        let remaining = 0;
        let expmsg = 0;

        let interval_id = null;
        const set_remaining = () => {
            remaining = end - start;
            if ( remaining < 0 ){
              clearInterval(interval_id);
              remove_auth_token(cookies);
              history.push('/session_expired');
            }
            if (remaining >= 0) {
              if ( remaining_session_time.current ){
                  remaining_session_time.current.innerText = convert_seconds(remaining);
                  remaining_session_time.current.className = 'session-time'
                  start = start + 1000; // 1 segundo
              }
            }
            if ( remaining > 0 && remaining <= 300000 && expmsg === 0 && session_expired_msg_enabled ) {
              expmsg = 1;
              toast.warning(
                  <Toast
                  title={intl.formatMessage(messages.yourSessionWillExpire5Min)}
                  content={intl.formatMessage(messages.saveOrBrowse)}
                  />,
                  { autoClose: 15000, toastId: 'yourSessionWillExpire' },
            );
            }
        }
        interval_id = setInterval(set_remaining, 1000);
        set_interval_id_to_session(interval_id);
      }
    }

  return (
    <>
    { is_active && renew_login_enabled && (
        <div class="session-timer">
          <span id="remaining-session-time" ref={remaining_session_time}></span>
        </div>
    )}
    </>
  );
};

export default LoginUnicoSessionTimer;